var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuppliers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 24.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "truck",
    transform: "translate(-0.2 -2.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1105",
    "data-name": "Rectangle 1105",
    d: "M.217-.8H19.285A1.017,1.017,0,0,1,20.3.217V16.742a1.017,1.017,0,0,1-1.017,1.017H.217A1.017,1.017,0,0,1-.8,16.742V.217A1.017,1.017,0,0,1,.217-.8ZM18.268,1.234H1.234V15.725H18.268Z",
    transform: "translate(1 3)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M16.217,7.2H21.3a1.017,1.017,0,0,1,.719.3l3.814,3.814a1.017,1.017,0,0,1,.3.719v6.356A1.017,1.017,0,0,1,25.115,19.4h-8.9A1.017,1.017,0,0,1,15.2,18.386V8.217A1.017,1.017,0,0,1,16.217,7.2ZM20.88,9.234H17.234v8.136H24.1V12.452Z",
    transform: "translate(4.068 1.356)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    d: "M3.395-.8A4.195,4.195,0,1,1-.8,3.395,4.2,4.2,0,0,1,3.395-.8Zm0,6.356A2.161,2.161,0,1,0,1.234,3.395,2.163,2.163,0,0,0,3.395,5.556Z",
    transform: "translate(3.542 19.525)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    d: "M3.395-.8A4.195,4.195,0,1,1-.8,3.395,4.2,4.2,0,0,1,3.395-.8Zm0,6.356A2.161,2.161,0,1,0,1.234,3.395,2.163,2.163,0,0,0,3.395,5.556Z",
    transform: "translate(20.068 19.525)",
    fill: "#00246a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuppliers);
export default __webpack_public_path__ + "static/media/Suppliers.f3a943dfa684deda4ee0f6eef3ea8e76.svg";
export { ForwardRef as ReactComponent };